import { history } from 'umi';

export const isStaticPage = () => {
  return history.location.pathname.startsWith('/static');
};
